"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
exports.__esModule = true;
exports.ProductPropertyUpdateDto = void 0;
var class_transformer_1 = require("class-transformer");
var class_validator_1 = require("class-validator");
var constants_1 = require("../../properties/constants");
var product_dto_1 = require("./product.dto");
var product_price_dto_1 = require("./product.price.dto");
var shared_1 = require("../../shared");
var ProductPropertyUpdateDto = (function (_super) {
    __extends(ProductPropertyUpdateDto, _super);
    function ProductPropertyUpdateDto() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.productCategory = 'PROPERTY';
        return _this;
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(__spread(constants_1.PROPERTY_TYPES)),
        __metadata("design:type", Object)
    ], ProductPropertyUpdateDto.prototype, "type");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsNotEmpty(),
        __metadata("design:type", String)
    ], ProductPropertyUpdateDto.prototype, "ratePlan");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsNotEmpty(),
        __metadata("design:type", String)
    ], ProductPropertyUpdateDto.prototype, "cancellationPolicy");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsNotEmpty(),
        __metadata("design:type", String)
    ], ProductPropertyUpdateDto.prototype, "contract");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsNotEmpty(),
        __metadata("design:type", String)
    ], ProductPropertyUpdateDto.prototype, "concept");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return Date; }),
        class_validator_1.IsDate(),
        __metadata("design:type", Date)
    ], ProductPropertyUpdateDto.prototype, "checkInDate");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return Date; }),
        class_validator_1.IsDate(),
        __metadata("design:type", Date)
    ], ProductPropertyUpdateDto.prototype, "checkOutDate");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsArray(),
        class_transformer_1.Type(function () { return shared_1.GuestDto; }),
        class_validator_1.ValidateNested({ each: true }),
        __metadata("design:type", Array)
    ], ProductPropertyUpdateDto.prototype, "adults");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsArray(),
        class_transformer_1.Type(function () { return shared_1.GuestDto; }),
        class_validator_1.ValidateNested({ each: true }),
        __metadata("design:type", Array)
    ], ProductPropertyUpdateDto.prototype, "children");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return product_price_dto_1.ProductPriceDto; }),
        __metadata("design:type", product_price_dto_1.ProductPriceDto)
    ], ProductPropertyUpdateDto.prototype, "price");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return product_price_dto_1.ProductPriceDto; }),
        __metadata("design:type", product_price_dto_1.ProductPriceDto)
    ], ProductPropertyUpdateDto.prototype, "cost");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Transform(function (value) { return (typeof value === 'object' ? value.id : value); }),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], ProductPropertyUpdateDto.prototype, "room");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Transform(function (value) { return (typeof value === 'object' ? value.id : value); }),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], ProductPropertyUpdateDto.prototype, "property");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], ProductPropertyUpdateDto.prototype, "market");
    return ProductPropertyUpdateDto;
}(product_dto_1.ProductDto));
exports.ProductPropertyUpdateDto = ProductPropertyUpdateDto;
//# sourceMappingURL=product-property-update.dto.js.map